export const ASSET_NAME = 'newsletter-page';


export const GET_USER_NEWSLETTER_REQUEST = 'app/NewsLetterPage/GET_USER_NEWSLETTER_REQUEST';
export const GET_USER_NEWSLETTER_SUCCESS = 'app/NewsLetterPage/GET_USER_NEWSLETTER_SUCCESS';
export const GET_USER_NEWSLETTER_ERROR = 'app/NewsLetterPage/GET_USER_NEWSLETTER_ERROR';


const initialState = {
    subscribedNewsLetter: null,
    fetchCheckSubsribedNewsLetterError: null,
};

const newsletterPageReducer = (state = initialState, action = {}) => {
    const { type, payload } = action;
   
    switch (type) {
        case GET_USER_NEWSLETTER_SUCCESS:
            return {
                ...state,
                newsLetterList:payload
            }

        case GET_USER_NEWSLETTER_ERROR:
            return { ...state, fetchCheckSubsribedNewsLetterError: payload }

        default:
            return state;
    }
};

export default newsletterPageReducer;


export const checkUserNewsLetterSucess = transaction => ({
    type: GET_USER_NEWSLETTER_SUCCESS,
    payload: {
        ...transaction
    }
});

export const checkUserNewsLetterError = error => ({
    type: GET_USER_NEWSLETTER_ERROR,
    error: true,
    payload: error,
});

export const getUserNewsLetterRequest = () => ({ type: GET_USER_NEWSLETTER_REQUEST });
export const getUserNewsLetterSuccess = () => ({ type: GET_USER_NEWSLETTER_SUCCESS, });
export const getUserNewsletterError = error => ({ type: NEWSLETTER_UPDATE_ERROR, payload: error, error: true });



export const loadData = (params, search, config) => dispatch => {
    return dispatch(searchUserNewsLetter(config))
};

export const searchUserNewsLetter = (config) => (dispatch, getState, sdk) => {
    dispatch(getUserNewsLetterRequest());

    return sdk.currentUser.show()
        .then(async response => {
            const { attributes, id } = response?.data?.data || {};
            const { email, profile } = attributes||{};
            dispatch(checkUserNewsLetterSucess(profile?.publicData));
            return response;
        })
        .catch(e => {
            dispatch(checkUserNewsLetterError(storableError(e)));
            throw e;
        });
}